// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d1c52349","453":"a4ce02c0","455":"9c33591f","977":"65b36dc4"}[chunkId] + ".chunk.js";
};